import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { faqs } from '../data/content';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full border-y border-surface-line bg-surface-alt" aria-labelledby="faq-titulo" data-id="element-42" data-mp="1he2xdzcpzofn">
      <div className="mx-auto max-w-3xl px-5 py-10 sm:px-6 sm:py-14" data-id="element-43" data-mp="1ccndiama3nyu">
        <h2 id="faq-titulo" className="font-display text-center text-[1.6rem] leading-[1.05] text-ink-strong sm:text-3xl" data-id="element-44" data-mp="2a1qgf9yce706">
          Preguntas frecuentes
        </h2>

        <ul className="mt-6 space-y-2" data-id="element-45" data-mp="202hp6ouv36hi">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.pregunta} className="overflow-hidden rounded-xl border border-surface-line bg-white" data-id="element-46" data-mp="oonpvjk9kdoh" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center gap-3 px-4 py-3.5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-brand" data-id="element-47" data-mp="johtjq31u302">
                  <span className="min-w-0 flex-1 text-[14px] font-bold text-ink-strong" data-id="element-48" data-mp="1fnc7xs7zfu0p">
                    {faq.pregunta}
                  </span>
                  <PlusIcon className={`h-4 w-4 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-49" data-mp="16nyygzjuz5fz" />
                </button>
                {isOpen && <p className="px-4 pb-4 text-[13px] leading-relaxed text-ink" data-id="element-50" data-mp="ixux6yu57hs5">
                    {faq.respuesta}
                  </p>}
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-7 max-w-sm" data-id="element-51" data-mp="2pmwybu4tulal">
          <CTAButton label="Quiero mi Airbnb ordenado" size="lg" fullWidth href="#precio" data-id="element-52" data-mp="2popzwv0l2fbq" />
          <p className="mt-2.5 text-center text-[11px] font-semibold text-ink-muted" data-id="element-53" data-mp="2fxvgdyeq1ttz">
            USD $19 · Pago único · Garantía 7 días
          </p>
        </div>
      </div>
    </section>;
}